import React, { Fragment } from 'react'
import '../../Css/LoadingTemplate.scss'

const Loading = () => {
    return(
        <Fragment>
            <div className= "loadingWrapper">
                <div className="loadingWrap">
                    <div class="loader">
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__ball"></div>
                    </div>
                    <p>Loading</p>
                </div>
            </div>
        </Fragment>
    )
}

export default Loading;